import { withRouter, Link } from "react-router-dom"
import React, { useState } from "react"
import {
  Card,
  Button,
  CardBody,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { getData } from "./data"
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import * as moment from "moment";

function Table(props) {
  const { data } = props
  const columns = [
    {
      dataField: "Supplier",
      text: "Supplier",
      sort: true,
    },
    {
      dataField: "Category",
      text: "Category",
      sort: true,
    },
    {
      dataField: "Bets",
      text: "Bets",
      sort: true,
      formatter: (cell, row) => <>{Number(row.Bets).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "TotalStake",
      text: "Total Stake",
      sort: true,
      formatter: (cell, row) => <>{Number(row.TotalStake).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "StakeTax",
      text: "Stake Tax",
      sort: true,
      formatter: (cell, row) => <>{Number(row.StakeTax).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "EffectiveStake",
      text: "Effective Stake",
      sort: true,
      formatter: (cell, row) => <>{Number(row.EffectiveStake).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "Boost",
      text: "Boost",
      sort: true,
      formatter: (cell, row) => <>{Number(row.Boost).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "WHT",
      text: "WHT",
      sort: true,
      formatter: (cell, row) => <>{Number(row.WHT ?? 0).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "Payout",
      text: "Pay out",
      sort: true,
      formatter: (cell, row) => <>{Number(row.Payout ?? 0).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "GGR",
      text: "GGR",
      sort: true,
      formatter: (cell, row) => <>{Number(row.GGR ?? 0).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "GGRRatio",
      text: "GGR Ratio",
      sort: true,
      formatter: (cell, row) => <>{Number(row.GGRRatio ?? 0).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "SupplierShare",
      text: "Supplier Share",
      sort: true,
      formatter: (cell, row) => <>{Number(row.SupplierShare ?? 0).toLocaleString('en-GB')}</>,
    },
    {
      dataField: "SupplierShareRatio",
      text: "Supplier Share Ratio",
      sort: true,
    },
  ]

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]

  const { SearchBar } = Search
  //pagination customization

  const pageOptions = {
    sizePerPage: 10,
    totalSize: getData().length,
    custom: true,
  }

  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Suppliers Report"}</div>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="id"
            columns={columns}
            data={data}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="id"
                data={data}
                columns={columns}
                bootstrap4
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row className="mb-2">
                      <Col sm="6">
                        <Row>
                          <Col sm="6">
                            <div className="search-box me-2 mb-2 d-inline-block">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </Col>
                          <Col sm="6">
                            <div>
                              <ReactHTMLTableToExcel
                                  id="test-table-xls-button"
                                  className="download-table-xls-button w-md btn btn-primary"
                                  table="table-to-xls"
                                  filename={`Supplier-Report-${moment(new Date()).format("DD/MM/YYYY")}`}

                                  sheet="tablexls"
                                  buttonText="Download"
                                  type="button"
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={6}></Col>
                    </Row>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable id="table-to-xls"
                            keyField="id"
                            responsive
                            bordered={false}
                            striped={false}
                            defaultSorted={defaultSorted}
                            //   selectRow={selectRow}
                            classes={
                              "table align-middle table-nowrap table-check"
                            }
                            headerWrapperClasses={"table-light"}
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                            rowClasses={"mytable-hover-row"}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pagination pagination-rounded justify-content-end">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </React.Fragment>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    </>
  )
}

export default Table
